import { Navigate, resolvePath, useLocation } from 'react-router-dom';
import { PropsWithChildren } from 'react';
import { useUser } from './AuthContext';
import { RoleType } from '../types/GroovUser';

interface Props extends PropsWithChildren<{}> {
  roles?: RoleType[];
  redirectPath?: string;
}

const ProtectedRoute = ({ roles = [], redirectPath = '/', children }: Props) => {
  const user = useUser();
  const location = useLocation();

  if (user.isLoading) {
    return null;
  }

  const resolvedPath = resolvePath(redirectPath, location.pathname);

  if (user.isError || !user.groovUser || !user.hasAccess(roles)) {
    return <Navigate to={resolvedPath} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
